export default function StickyNav({ scrolled }: { scrolled: boolean }) {
  const handleMenu = () => {
    window.REACT_APP_NAVIGATE('/menu');
  };

  const handleAvis = () => {
    document.getElementById('avis')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleEvenements = () => {
    window.REACT_APP_NAVIGATE('/evenements');
  };

  const handleAPropos = () => {
    window.REACT_APP_NAVIGATE('/a-propos');
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white shadow-md'
          : 'bg-gradient-to-b from-black/30 to-transparent'
      }`}
    >
      <div className="w-full px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div
              className={`text-3xl font-serif font-bold transition-colors cursor-pointer ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
              onClick={() => window.REACT_APP_NAVIGATE('/')}
            >
              Ke'iki
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="flex items-center gap-3">
            <button
              onClick={handleAPropos}
              className={`flex items-center gap-1.5 px-3 sm:px-4 py-2 rounded-full transition-all text-sm font-medium whitespace-nowrap cursor-pointer border ${
                scrolled
                  ? 'bg-gray-100 hover:bg-gray-200 text-gray-700 border-gray-200'
                  : 'bg-white/20 backdrop-blur-md border-white/40 hover:bg-white/30 text-white shadow-md'
              }`}
            >
              <i className="ri-information-line"></i>
              <span className="hidden md:inline">À propos</span>
            </button>

            <button
              onClick={handleMenu}
              className={`flex items-center gap-1.5 px-3 sm:px-4 py-2 rounded-full transition-all text-sm font-medium whitespace-nowrap cursor-pointer border ${
                scrolled
                  ? 'bg-gray-100 hover:bg-gray-200 text-gray-700 border-gray-200'
                  : 'bg-white/20 backdrop-blur-md border-white/40 hover:bg-white/30 text-white shadow-md'
              }`}
            >
              <i className="ri-restaurant-line"></i>
              <span className="hidden md:inline">Menu</span>
            </button>

            <button
              onClick={handleEvenements}
              className={`flex items-center gap-1.5 px-3 sm:px-4 py-2 rounded-full transition-all text-sm font-medium whitespace-nowrap cursor-pointer border ${
                scrolled
                  ? 'bg-gray-100 hover:bg-gray-200 text-gray-700 border-gray-200'
                  : 'bg-white/20 backdrop-blur-md border-white/40 hover:bg-white/30 text-white shadow-md'
              }`}
            >
              <i className="ri-calendar-event-line"></i>
              <span className="hidden sm:inline">Événements</span>
            </button>

            <button
              onClick={handleContact}
              className={`flex items-center gap-1.5 px-3 sm:px-4 py-2 rounded-full transition-all text-sm font-medium whitespace-nowrap cursor-pointer border ${
                scrolled
                  ? 'bg-teal-500 hover:bg-teal-600 text-white border-teal-500'
                  : 'bg-white/90 backdrop-blur-md border-white hover:bg-white text-gray-900 shadow-md'
              }`}
            >
              <i className="ri-phone-line"></i>
              <span className="hidden sm:inline">Contact</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
